// components/RankingsCard.js

import React from "react";

const RankingsCard = ({ data }) => {
  return (
    <div className="m-0 px-2">

      {data.map((item, index) => (
        // <div className="row m-0 p-0">
        //     <div className="col-8 m-0 p-0">
        //         <h5>
        //             #{index + 1} - {item.participante}
        //         </h5>
        //     </div>
        //     <div className="col-4 m-0 p-0">
        //         <p>Tiempo: {item.formatted_time}</p>
        //     </div>
        // </div>
        <div className="row align-items-center mb-1" style={{borderBottom: "solid"}}>
            <div className="col-6">
                <div className="fw-bold">#{index + 1} - {item.participante}</div>
                <small className="text-muted">{item.activity}</small>
            </div>
            <div className="col-3 text-center small text-muted">
                T1: {item.formatted_time_one}
            </div>
            <div className="col-3 text-center small text-muted">
                T2: {item.formatted_time_two}
            </div>
            {/* <div className="col-4 text-end">
                <span className="badge bg-success fs-5">
                    Total: {item.formatted_total}
                </span>
            </div> */}
        </div>
      ))}
    </div>
  );
};

export default RankingsCard;